module.exports = __webpack_public_path__ + "static/img/bg_3_15.570634e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_3_15.png
// module id = 7hqe
// module chunks = 3